import { Capacitor } from "@capacitor/core";

/**
 * Base URL para resolver imágenes estáticas del backend.
 * - En nativo (Android/iOS): URL absoluta de Tailscale
 * - En web: cadena vacía → rutas relativas que nginx resuelve
 */
const getImageBase = () => {
  if (Capacitor.isNativePlatform()) {
    return process.env.NODE_ENV === "production"
        ? "https://tahuya.taile75a0b.ts.net"
        : "http://192.168.1.50:8000";
  }
  return ""; // Web: nginx hace el proxy
};

/**
 * Convierte una ruta de imagen relativa en URL absoluta.
 * Ejemplo: "/static/user_1.png" → "https://tahuya.taile75a0b.ts.net/static/user_1.png"
 *
 * @param {string} src - Ruta de la imagen
 * @returns {string} - URL resuelta
 */
export function resolveAvatarUrl(src) {
  if (!src) return "";

  // Si ya es URL absoluta (http/https), devolverla tal cual
  try {
    new URL(src);
    return src;
  } catch (_) {}

  // Si es ruta relativa, añadir la base correcta según plataforma
  if (src.startsWith("/")) {
    return `${getImageBase()}${src}`;
  }

  return src;
}